<template>
  <div class="votes">
    <span class="votesCounters">
      {{ getAbbreviation(votes[VOTE.UP]) }}
    </span>
    <v-icon
      :class="{
        'voteSet': currentUserVoteType === VOTE.UP,
        'votesIcons ml-1': true,
      }"
      @click="voteClick(VOTE.UP)"
    >
      arrow_drop_up
    </v-icon>

    <span class="votesCounters">
      {{ getAbbreviation(votes[VOTE.QUESTION]) }}
    </span>
    <v-icon
      small
      :class="{
        'voteSet': currentUserVoteType === VOTE.QUESTION,
        'votesIcons ml-1': true,
      }"
      @click="voteClick(VOTE.QUESTION)"
    >
      help_outline
    </v-icon>

    <span class="votesCounters">
      {{ getAbbreviation(votes[VOTE.DOWN]) }}
    </span>
    <v-icon
      :class="{
        'voteSet': currentUserVoteType === VOTE.DOWN,
        'votesIcons ml-1': true,
      }"
      @click="voteClick(VOTE.DOWN)"
    >
      arrow_drop_down
    </v-icon>
  </div>
</template>
<script>
import { abbreviateNumber } from '../../tools/numberUtils';
import { VOTE } from '../../store/votes';

export default {
  name: 'ElementVotes',
  props: {
    votes: {
      type: Object,
      default: () => ({
        [VOTE.UP]: 0,
        [VOTE.QUESTION]: 0,
        [VOTE.DOWN]: 0,
      }),
    },
    currentUserVoteType: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    voteClick(voteType) {
      const newType = voteType === this.currentUserVoteType ? VOTE.NONE : voteType;
      this.$emit('voteClick', newType);
    },
    getAbbreviation(number) {
      return number ? abbreviateNumber(number) : '';
    },
  },
  created() {
    this.VOTE = VOTE;
  },
};
</script>
<style scoped>
.votes {
  display: grid;
  grid-template-columns: 8px 20px;
  grid-template-rows: 20px 20px 20px;
  gap: 0px 2px;
}
.votesCounters {
  font-size: 11px;
  /* line-height: 20px; */
  justify-self: end;
  align-self: center;
}
.votesRow {
  margin-bottom: 4px;
  margin-top: 0px;
}
.votesCountersInsideAnalysis {
  position: absolute;
  left: -36px;
  width: 30px
}
.voteSet {
  color: #06D6A0;
}
.votesIcons {
  width: 16px;
  height: 16px;
  color: default;
}
.votesIcons:hover {
  color: #06D6A0;
}
.votesIcons:focus::after {
  opacity: 0;
}
</style>
